import { useQuery } from "@tanstack/react-query"
import { api, useRoleConf } from "../../hooks"
import { datarefQueryRoleconf } from "../datarefQuery.roleconf"
import { datarefToReferentialCode } from "../datarefToReferentialCode"
import { uppDataRefApiRoleConf } from "./uppDataref.roleconf"
import type { UppsDatarefApi } from "./uppDataref.type"

export const useGetUppDataref = () => {
  const { endpoint, queryKey } = useRoleConf(uppDataRefApiRoleConf())
  const queryOptions = useRoleConf(datarefQueryRoleconf())

  const { data: uppDataref = [], isLoading: uppDatarefIsLoading } = useQuery({
    queryKey,
    queryFn: () => api.get<UppsDatarefApi>(endpoint),
    ...queryOptions,
  })

  const uppReferential = datarefToReferentialCode(uppDataref)

  return { uppDataref, uppDatarefIsLoading, uppReferential }
}
